export default __webpack_public_path__ + "static/media/19-LineMusic-Black.dbdb4c22.png";